module.exports = __webpack_public_path__ + "static/coolinarycafe-logo-ac607784905c8ecb08afe6ad9cf76ec9.png";